<script setup lang="ts">
import { resolveHeaderBird } from '~/utils/header-bird'

const { environment, timeZone } = useRuntimeConfig().public
const localePath = useLocalePath()
const { appBarLogoRed, registrationPageLogo, seasonalHeaderBirds = [] } = useCountryConfig()

const logoSrc = computed(() => appBarLogoRed ?? registrationPageLogo)
const bird = computed(() => resolveHeaderBird(new Date(), seasonalHeaderBirds, timeZone))
</script>

<template>
  <NuxtLink
    :to="localePath('/')"
    data-nav-id="header_logo"
    class="d-flex align-center ga-3 py-1"
  >
    <nuxt-picture
      :src="bird.src"
      :width="bird.width"
      :height="bird.height"
      alt=""
    />
    <v-badge
      v-if="environment !== 'prod'"
      :content="environment"
      :color="environment === 'staging' ? 'heiland-light-blue' : 'heiland-purple'"
    >
      <nuxt-picture
        :src="logoSrc"
        width="128"
        height="30"
        alt="Logo"
      />
    </v-badge>
    <nuxt-picture
      v-else
      :src="logoSrc"
      width="128"
      height="30"
      alt="Logo"
    />
  </NuxtLink>
</template>
